const errorHandler = function (e) {
  throw new Error(`Syntax error, unrecognized expression: ${e}`);
};

$.find.error = errorHandler;
